import { createActions } from 'reduxsauce';
import { IPage } from 'store/donatePage/types';

export interface SetsState {
  data: SetsData;
  isLoading: boolean;
  error: string;
}

export type SetsData = {
  bottom_section: boolean;
  display_fundraising_bar: boolean;
  end_date: string;
  fundraising_donation_count: number;
  fundraising_goal: string;
  fundraising_raised: string;
  is_enabled: boolean;
  latest_fundraising_location: string;
  querystring: string;
  set_desc: string;
  set_desc_2: string;
  set_desc_3: string;
  set_id: string;
  set_misc: ISetMisc;
  set_pages: FundraisingPage[];
  set_title: string;
  set_title_2: string;
  set_title_3: string;
  set_type: string;
  start_date: string;
  pages: IPage[];
  image_filenames?: {
    header_logo?: string;
    header_video?: string;
    [key: string]: string | undefined;
  };
};

export type ISetMisc = {
  donate_custom_1: string;
  donate_custom_1_helper?: string;
  goal_alt?: string;
  has_header_video?: boolean;
  has_header_logo?: boolean;
  has_share?: boolean;
  header_bg_color?: string;
  hide_recent_location?: string;
  issue_misc?: IMisc;
  primary_color?: string;
  secondary_color?: string;
  tertiary_color?: string;
  sections?: ISection[];
  share_alt?: string;
  share_disclaimer?: string;
  share_title?: string;
  share_description?: string;
  show_header_button?: boolean;
  whitelabeled?: boolean;
};

export type IMisc = {
  card_goal_alt?: string;
  card_helper_text?: string;
  card_raised_alt?: string;
  cta_color?: string;
  edge_color?: string;
};

export const SECTION_LAYOUT = {
  IMAGE_CENTER_BOTTOM: 'IMAGE_CENTER_BOTTOM',
  IMAGE_CENTER_TOP: 'IMAGE_CENTER_TOP',
  IMAGE_LEFT: 'IMAGE_LEFT',
  IMAGE_RIGHT: 'IMAGE_RIGHT',
  NO_IMAGE: 'NO_IMAGE',
} as const;

export type SectionLayout = (typeof SECTION_LAYOUT)[keyof typeof SECTION_LAYOUT];

export type ISection = {
  background_color?: string;
  text_color?: string;
  button_copy?: string;
  cta_button_color?: string;
  description?: string;
  has_image?: boolean;
  id?: string;
  image_preview?: string;
  layout?: SectionLayout | string;
  redirect_link?: string;
  show_button?: boolean;
  title?: string;
};

export type ITrendingIssue = {
  id: number;
  name: string;
  redirect_url: string;
  raised: string;
  fundraising_goal: string;
  cta: string;
};

export type FundraisingPage = {
  latest_fundraising_transactions: FundraisingTransaction[];
  learn_more_link: string;
  page_fundraising_donation_count: number;
  page_fundraising_goal: string;
  page_fundraising_raised: string;
  page_id: number;
};

export type FundraisingTransaction = {
  amount: string;
  city: string;
  state: string;
  transaction_date: string;
};

export interface SetsTypes {
  SETS: 'SETS';
  SETS_START: 'SETS_START';
  SETS_SUCCESS: 'SETS_SUCCESS';
  SETS_ERROR: 'SETS_ERROR';
  SETS_CLEAN_UP: 'SETS_CLEAN_UP';
}

const { Types, Creators } = createActions<SetsTypes>({
  sets: ['data'],
  setsStart: null,
  setsSuccess: ['data'],
  setsError: ['error'],
  setsCleanUp: null,
});

export { Types };

export default Creators;
